export default class NewsletterPopup {
	constructor(newsletter) {

        this.newsletter = newsletter;
        if(this.newsletter.isSubscribed) {
            return;
        }

        this.isShown = localStorage?.getItem('newsletterPopup') || localStorage?.getItem('newsletter') === 'subscribed';
        if(this.isShown) {
            return;
        }

        this.wasClosed = false;

		this.delay = this.newsletter.newsletter.getAttribute('data-popup-delay');
        this.waitForIt();

        document.addEventListener('click', e => {
			if (e.target && !e.target.closest('[data-newsletter]') || e.target.closest('[data-close-popup]')) {
				this.hide();
			}
        });

        document.addEventListener('bless', ({ detail }) => {
            if(this.timeout) {
                clearTimeout(this.timeout);
            }
        });

	}

    waitForIt() {
        if(this.wasClosed) {
            return;
        }

        this.timeout = setTimeout(() => {
            this.show();
        }, this.delay*1000);
    }

	show() {
		document.body.classList.add('body--newsletter-popup');
        localStorage.setItem('newsletterPopup', 'shown');
	}

	hide() {
		document.body.classList.remove('body--newsletter-popup');
        this.wasClosed = true;
	}

}
